import DrawerPresentation from 'components/Drawer/DrawerPresentation'

export default {
  Presentation: DrawerPresentation,
}
